
import Vue from "vue";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
// import { gmapApi } from "vue2-google-maps";
import { mapState, mapActions } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
Vue.component("GmapCluster", GmapCluster);

export default {
  components: { noDataLabel },
  // components: {
  //   GmapCluster
  // },
  data() {
    return {
      showMap: false,
      bounds: null,

      locations: [],
      mapStyle: {
        mapTypeControl: false,
        streetViewControl: false,
        styles: [
          {
            featureType: "all",
            elementType: "geometry.fill",
            stylers: [
              {
                weight: "2.00"
              }
            ]
          },
          {
            featureType: "all",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#9c9c9c"
              }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "on"
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [
              {
                color: "#f2f2f2"
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 45
              }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#eeeeee"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#7b7b7b"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [
              {
                visibility: "simplified"
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                color: "#46bcec"
              },
              {
                visibility: "on"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#c8d7d4"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#070707"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("report", ["deliveredLocations", "deliveredLocationsLoading"]),
    ...mapState("restaurant", ["locationDetails"]),
    formattedDeliveredLocations() {
      return this.deliveredLocations?.locations?.map((item) => {
        return { lat: Number(item.lat), lng: Number(item.lng) };
      });
    },
    mapCenter() {
      return {
        lat: Number(this.locationDetails.latitude),
        lng: Number(this.locationDetails.longitude)
      };
    }
    // google: gmapApi
  },

  mounted() {
    this.fetchDeliveryLocations();
  },
  methods: {
    ...mapActions("report", ["getDeliveryLocations"]),
    async fetchDeliveryLocations(backgroundLoad = true) {
      await this.getDeliveryLocations({
        backgroundLoad
      });
      // this.bounds = new google.maps.LatLngBounds();
      // this.deliveredLocations.locations.forEach(marker => {
      //   const loc = new google.maps.LatLng(marker.lat, marker.lng);
      //   this.bounds.extend(loc);
      // });

      this.$nextTick(() => {
        this.showMap = true;
        if (this.$refs.mapRef) {
          this.$refs.mapRef?.$mapPromise?.then((map) => {
            const bounds = new google.maps.LatLngBounds();
            // map.fitBounds(bounds);
            map.panToBounds(bounds);
          });
        }
      });
    }
  }
};
